import { useMutation, useQueryClient } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useArchiveCostCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => costCategoriesApi.archive(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
      });
      toast.success('Kategoria kosztów została zarchiwizowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas archiwizacji kategorii kosztów.',
      });
    },
  });
}
